import axios from 'axios'
import { API_HOST } from '../constants/const'

let client

export default client = axios.create({
  baseURL: `${API_HOST}`,
  headers: {
    'Content-Type': 'application/json',
    // REFERER: 'http://127.0.0.1:3000', // ブラウザが安全でないヘッダーとして拒否するためコメントアウト
  },
  withCredentials: true,
})

client.interceptors.response.use((response) => {
  const data = response.data
  return { ...response.data, data }
})

client.interceptors.request.use(
  (config) => {
    // Add CSRF token for non-GET requests
    if (
      config.method &&
      ['post', 'patch', 'put', 'delete'].includes(config.method.toLowerCase())
    ) {
      const csrfToken =
        document.querySelector<HTMLMetaElement>('[name=csrf-token]')?.content ||
        document.querySelector<HTMLInputElement>('[name=csrfmiddlewaretoken]')
          ?.value
      if (csrfToken) {
        config.headers = {
          ...config.headers,
          'X-CSRFToken': csrfToken,
        }
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
